export default {
    subtitle: 'This feature is under development.',
    title: 'Coming soon',
    description: 'This page is not yet available. Check back later.',
}
